const { platform } = window.electron;
const { experimentalVideoSourceDropdown } = window.electron.runtimeConfig;
const isMac = platform === 'darwin';
const isWindows = platform === 'win32';

export { platform, isMac, isWindows, experimentalVideoSourceDropdown };
